import * as Sentry from '@sentry/nuxt'

export default defineNuxtPlugin(() => {
  onNuxtReady(async () => {
    import('@sentry/browser').then((lazyLoadedSentry) => {
      Sentry.addIntegration(lazyLoadedSentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        networkDetailAllowUrls: ['localhost', window.location.origin],
        networkRequestHeaders: ['Cache-Control', 'Content-Type', 'Accept', 'Accept-Language', 'Authorization', 'Cookie', 'Origin', 'Referer', 'User-Agent'],
        networkResponseHeaders: ['Cache-Control', 'Content-Type', 'Accept', 'Accept-Language', 'Authorization', 'Cookie', 'Origin', 'Referer', 'User-Agent'],
      }))
    })
  })
})
